import React from "react"
import { FormControl, InputLabel, Select, MenuItem } from "@mui/material"
import { useFormikContext } from "formik"
import i18n from "@/i18n"
import { getMaxAdvanceOptions, getMinAdvanceOptions } from "@/constants/reservation_rules"
import { SETTINGS_SECTION_STYLES } from "@/components/settings/_styles"

const STYLES = {
  ...SETTINGS_SECTION_STYLES,
} as const

const BookingWindow: React.FC = () => {
  const { values, setFieldValue } = useFormikContext<any>()

  const maxAdvanceOptions = getMaxAdvanceOptions()
  const minAdvanceOptions = getMinAdvanceOptions()

  return (
    <div className={STYLES.container} data-testid="settings-venue-rules-booking-window-container">
      <h2 className={STYLES.header}>{i18n.t("app.settings.venues.reservation_rules.booking_window.title")}</h2>
      <div className={STYLES.grid}>
        <FormControl fullWidth>
          <InputLabel id="max-advance-label">
            {i18n.t("app.settings.venues.reservation_rules.fields.max_advance")}
          </InputLabel>
          <Select
            labelId="max-advance-label"
            label={i18n.t("app.settings.venues.reservation_rules.fields.max_advance")}
            value={values.maxAdvanceBooking}
            onChange={(e) => setFieldValue("maxAdvanceBooking", e.target.value)}
            data-testid="settings-venue-rules-booking-window-select-max-advance"
          >
            {maxAdvanceOptions.map((o) => (
              <MenuItem key={o.value} value={o.value}>
                {o.label}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        <FormControl fullWidth>
          <InputLabel id="min-advance-label">
            {i18n.t("app.settings.venues.reservation_rules.fields.min_advance")}
          </InputLabel>
          <Select
            labelId="min-advance-label"
            label={i18n.t("app.settings.venues.reservation_rules.fields.min_advance")}
            value={values.minAdvanceBooking}
            onChange={(e) => setFieldValue("minAdvanceBooking", e.target.value)}
            data-testid="settings-venue-rules-booking-window-select-min-advance"
          >
            {minAdvanceOptions.map((o) => (
              <MenuItem key={o.value} value={o.value}>
                {o.label}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </div>
      <p className={STYLES.helperText}>{i18n.t("app.settings.venues.reservation_rules.helpers.booking_window")}</p>
    </div>
  )
}

export default BookingWindow
